import React from 'react'
import { css } from '@emotion/core'

type AddButtonProps = {
  label?: string
  onClick: () => void
}

export const AddButton: React.FC<AddButtonProps> = ({ label = '', onClick }) => {
  return (
    <div css={wrapperStyle} className={'field'}>
      <button onClick={onClick} css={buttonStyle}>
        {label}
      </button>
    </div>
  )
}

const wrapperStyle = css({})

const buttonStyle = css({
  appearance: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  padding: '12px 13px 12px 38px',
  color: '#FFFFFF',
  backgroundColor: '#004CAD',
  borderRadius: '6px',
  fontSize: '12px',
  cursor: 'pointer',
  backgroundImage: `url(${require('@/static/images/add.svg')})`,
  backgroundPosition: 'left 10px center',
  backgroundSize: '24px',
  backgroundRepeat: 'no-repeat',
  '&:hover': {
    opacity: 0.8,
  },
})
